<!--
 * @Descripttion: 
 * @version: 倒计时组件
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: hongye
 * @LastEditTime: 2025-03-26 17:51:47
-->
<template>
  <div class="count-down send-sms-code-btn">
    <Button type="link" @click="sendSmsCode" :loading="loading" :disabled="codeIsDisabled" v-if="!btnDisabled">{{ $lang('获取') }}</Button>
    <Button type="link" :disabled="btnDisabled" v-else> {{ second }} s </Button>
    <Verify
      mode="pop"
      captchaType="blockPuzzle"
      :imgSize="{ width: '400px', height: '200px' }"
      ref="verify"
      @success="success"
    ></Verify>
  </div>
</template>
<script lang="ts" setup>
  import { onBeforeMount, ref, watch, computed, onMounted } from 'vue'
  import { Button, message } from 'ant-design-vue'
  import { Verify } from '@tmp/site-common'
  import { isSuccess, lang } from '@/utils/index'
  import { ajaxAuthService } from '@/service/api'
  import { EMAIL_REG } from '@/utils/validator'
  import dayjs from 'dayjs'
  import { useRouter } from 'vue-router'
  const router = useRouter()
  const routerName = String(router.currentRoute.value.name ?? '')
  interface Prop {
    second?: number
    email: string
    allowStorage?: boolean
  }
  const props = withDefaults(defineProps<Prop>(), {
    second: 120,
    email: '',
    allowStorage: false
  })
  const emit = defineEmits(['openVerify', 'success'])
  const codeIsDisabled = computed(() => {
    return !(props.email && EMAIL_REG.test(props.email))
  })
  let timer = null as any
  const second = ref(props.second - 1)
  /** 按钮是否可点击，false可点击 */
  const btnDisabled = ref(false)
  const verify = ref()
  /**
   * 发送短信验证前置检验
   */
  const sendSmsCode = () => {
    /** 打开滑块验证码 */
    emit('openVerify', () => {
      verify.value.show()
    })
  }
  const loading = ref(false)
  const success = async (e: { captchaVerification: string }) => {
    try {
      loading.value = true
      const res = await ajaxAuthService.sendEmail({
        email: props.email,
        captchaVerification: e.captchaVerification,
        messageType: 'EMAIL_CAPTCHA',
        platform: 'CAPTCHA'
      })
      loading.value = false
      if (isSuccess(res)) {
        message.success(lang('获取成功!'))
        emit('success', e)
        second.value = (res.data ?? 60) - 1
        props.allowStorage && localStorage.setItem(`emailCode-${routerName}`, JSON.stringify({
          email: props.email,
          code: dayjs().add(second.value, 'second').format('YYYY-MM-DD HH:mm:ss')
        }))
        handleCountDown()
      }
    } catch (error) {
      loading.value = false
    }
  }
  /**
   * 开始倒计时
   */
  const handleCountDown = () => {
    timer = setInterval(() => {
      second.value -= 1
    }, 1000)
    btnDisabled.value = true
  }

  /**
   * 倒计时结束，按钮可点击
   */
  watch(
    () => second.value,
    () => {
      if (second.value < 0) {
        timer && clearInterval(timer)
        btnDisabled.value = false
        second.value = props.second - 1
      }
    }
  )

  /**
   * 清空倒计时
   */
  onBeforeMount(() => {
    clearInterval(timer)
  })
  onMounted(() => {
    const emailCode = localStorage.getItem(`emailCode-${routerName}`)
    if (props.allowStorage && emailCode && props.email) {
      const { email, code } = JSON.parse(emailCode)
      if (email !== props.email) {
        localStorage.removeItem(`emailCode-${routerName}`)
        return 
      }
      if (code && dayjs(code).isBefore(dayjs())) {
        localStorage.removeItem(`emailCode-${routerName}`)
        return 
      }
      second.value = dayjs(code).diff(dayjs(), 'second')
      handleCountDown()
    }
  })

  defineExpose({ handleCountDown })
</script>
<style lang="less" scoped></style>
